const Routes = Object.freeze({
  HOME: "/",
  ABOUT: "/about",

  //lecture
  LECTURE_STATS: "/meeting/:lectureNum/stats",
  LECTURE_PRESENTATION: "/meeting/:lectureNum/presentation",
  LECTURE_LIVE: "/meeting/:lectureNum/live",
  PAGE_QUESTION_ANSWERS: "/meeting/:lectureNum/questions/:questionId",
  // teacher
  TEACHER_LOGIN: "/teacher-login",
  REGISTER_TEACHER: "/register-teacher",
  TEACHER_MY_COURSE: "/teacher/my-courses",
  TEACHER_MY_LECTURES: "/organizer/my-meetings",
  TEACHER_NOTIFICATIONS: "/organizer/notifications",
  TEACHER_MY_COURSES_ADD: "/organizer/my-courses/add",
  TEACHER_MY_COURSES_EDIT: "/organizer/my-courses/edit/:id",
  TEACHER_MY_LECTURES_ADD: "/organizer/my-meetings/add",
  TEACHER_MY_LECTURES_EDIT: "/organizer/my-meetings/edit/:lectureNum",
  TEACHER_CLASS_STATUS: "/organizer/class-status",
  TEACHER_STATS: "/organizer/stats",
  ADMIN_STATS: "/organizer/admin-stats",
  TEACHER_SLIDE_STATS: "/organizer/slide-stats",
  TEACHER_SETTINGS: "/organizer/settings",
  TEACHER_HOW_IT_WORKS: "/organizer/how-it-works",
  TEACHER_REMOTE: "/organizer/:lectureNum/remote",
  TEACHER_MY_QUESTIONS: "/organizer/my-questions",
  TEACHER_MY_ANSWERS: "/organizer/my-answers",
  TEACHER_MY_DISCUSSIONS: "/organizer/my-discussions",
  TEACHER_QUESTIONS: "/meeting/:lectureNum/questions",

  // student
  REGISTER_STUDENT: "/register-participant",
  OLD_OR_NEW_STUDENT: "/old-or-new-participant",
  STUDENT_MY_COURSE: "/participant/my-courses",
  STUDENT_MY_COURSES_ADD: "/participant/my-courses/add",
  STUDENT_MY_LECTURES: "/participant/my-meetings",
  PICK_CARD: "/pick-card",
  STUDENT_WAITING_ROOM: "/waiting-room",
  STUDENT_DOWNLOAD_PASSWORD: "/download-password",
  STUDENT_DOWNLOAD_PASSWORD_MOBILE: "/download-password-mobile",
  STUDENT_MY_QUESTIONS: "/participant/my-questions",
  STUDENT_MY_ANSWERS: "/participant/my-answers",
  STUDENT_MY_DISCUSSIONS: "/participant/my-discussions",
  STUDENT_NOTIFICATIONS: "/participant/notifications",
  STUDENT_SETTINGS: "/participant/settings",
  STUDENT_HOW_IT_WORKS: "/participant/how-it-works",

  // shared
  FEEDBACK: "/feedback",
});

export default Routes;
